package fr.frux.core.maps

import androidx.compose.ui.graphics.Color
import kotlin.jvm.JvmInline

/** Identifiant opaque d'une plaque, cote appelant. */
@JvmInline
value class PlaqueId(
    val value: Long,
)

/**
 * Une plaque carree a dessiner sur la carte, a cote des epingles rondes de [MapMarker].
 *
 * Volontairement depourvue de vocabulaire metier, comme [MapMarker] : `core-maps` ne sait pas ce
 * qu'est un lieu ni ce que signifie un cadenas. L'appelant traduit son modele en teinte, en cle de
 * glyphe et en texte de badge.
 */
data class MapPlaque(
    val id: PlaqueId,
    val position: Location,
    val tint: Color,
    /** Cle de glyphe resolue dans les sprites passes a la carte, ou null pour une plaque nue. */
    val iconKey: String?,
    /** Texte court pose en pastille au coin de la plaque (« 8+ », « ? »), ou null pour aucun. */
    val badge: String? = null,
    /** Pastille de badge a la couleur d'accent plutot que sombre (date de recolte, pas un effectif). */
    val badgeAccent: Boolean = false,
    /** Bord ambre plutot que blanc, meme sens visuel que [MapMarker.soon]. */
    val soon: Boolean = false,
    val selected: Boolean = false,
    /** Libelle pour les lecteurs d'ecran. Jamais dessine sur la carte. */
    val label: String? = null,
)
